
export class ClienteUnidadeNegocioInsert {
    idCliente: number;
    idUnidadeNegocio: number;
    idMercado: number;
    idNaturezaVenda: number;
    idItemTipo: number;

    constructor(idCliente: number) {
        this.idCliente = idCliente;
    }
}
